export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Esta ação excluirá permanentemente o ativo"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tem certeza que deseja continuar?"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sim"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancelar"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Você não verá mais este ativo em sua lista."])}
}